import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '../../components/directives/directives.module';
import { ModalContentActionsComponent } from './modal-content-actions/modal-content-actions.component';
import { ModalContentTitleComponent } from './modal-content-title';
import { ModalContentComponent } from './modal-content/modal-content.component';
import { ModalFooterComponent } from './modal-footer/modal-footer.component';
import { ModalHeaderComponent } from './modal-header';
import { ModalHeaderActionsComponent } from './modal-header-actions/modal-header-actions.component';
import { ModalHeaderAltActionsComponent } from './modal-header-alt-actions/modal-header-alt-actions.component';
import { ModalHeaderDropdownComponent } from './modal-header-dropdown/modal-header-dropdown.component';
import { ModalIntroComponent } from './modal-intro/modal-intro.component';
import { ModalPreheaderContentComponent } from './modal-preheader-content/modal-preheader-content.component';
import { ModalSidebarComponent } from './modal-sidebar/modal-sidebar.component';
import { ModalTwoColumnsContentComponent } from './modal-two-columns-content/modal-two-columns-content.component';
import { ModalComponent } from './modal.component';

@NgModule({
  imports: [CommonModule, DirectivesModule],
  declarations: [
    ModalHeaderComponent,
    ModalHeaderActionsComponent,
    ModalHeaderAltActionsComponent,
    ModalFooterComponent,
    ModalContentTitleComponent,
    ModalIntroComponent,
    ModalContentComponent,
    ModalContentActionsComponent,
    ModalTwoColumnsContentComponent,
    ModalComponent,
    ModalPreheaderContentComponent,
    ModalHeaderDropdownComponent,
    ModalSidebarComponent,
  ],
  exports: [
    ModalHeaderComponent,
    ModalHeaderActionsComponent,
    ModalHeaderAltActionsComponent,
    ModalFooterComponent,
    ModalContentTitleComponent,
    ModalIntroComponent,
    ModalContentComponent,
    ModalContentActionsComponent,
    ModalTwoColumnsContentComponent,
    ModalComponent,
    ModalHeaderDropdownComponent,
    ModalPreheaderContentComponent,
    ModalSidebarComponent,
  ],
})
export class ModalComponentsCommonModule {}
